import { useEffect, lazy, Suspense } from 'react';
import { Routes, Route, BrowserRouter, Navigate } from "react-router-dom";
import { Spin } from 'antd';
import axios from 'axios';
import './App.css';

import { RouteTracker } from './utils/appInsights';
import Authentication from './pages/Authentication';
import AccessDeniedPage from './pages/AccessDeniedPage';
import ProtectedRoute from './components/ProtectedRoute';

const ChatPage = lazy(() => import('./pages/ChatPage'));
const ChatListPage = lazy(() => import('./pages/ChatListPage'));
const AdminHistoryPage = lazy(() => import('./pages/AdminHistoryPage'));
const FeedbackPage = lazy(() => import('./pages/FeedbackPage'));

const LOADING_FALLBACK = (
  <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
    <Spin size="large" />
  </div>
);

const protectedRoutes: { path: string; element: React.ReactElement; adminOnly?: boolean }[] = [
  { path: '/chat',                              element: <ChatPage /> },
  { path: '/chat/:id',                          element: <ChatPage /> },
  { path: '/chat-list',                         element: <ChatListPage /> },
  { path: '/admin/history',                     element: <AdminHistoryPage />, adminOnly: true },
  { path: '/admin/feedback',                    element: <FeedbackPage />,     adminOnly: true },
];

function App() {
  useEffect(() => {
    const interceptor = axios.interceptors.response.use(
      (response) => response,
      (error) => {
        if (error.response?.status === 401) {
          sessionStorage.removeItem('token');
          window.location.replace('/login');
        }
        return Promise.reject(error);
      }
    );
    return () => axios.interceptors.response.eject(interceptor);
  }, []);

  return (
    <BrowserRouter>
      <RouteTracker />
      <div className="App">
        <Suspense fallback={LOADING_FALLBACK}>
          <Routes>
            <Route index element={<Navigate to="/login" replace />} />
            <Route path="/login" element={<Authentication />} />
            <Route path="/access-denied" element={<AccessDeniedPage />} />
            {protectedRoutes.map(({ path, element, adminOnly }) => (
              <Route key={path} path={path} element={<ProtectedRoute adminOnly={adminOnly}>{element}</ProtectedRoute>} />
            ))}
          </Routes>
        </Suspense>
      </div>
    </BrowserRouter>
  );
}

export default App;
